import retry from '@blockcatio/tabby-library/lib/utilities/retry';

import { tokenInfoUpdate, tokenInfoUpdateFailed } from '../actions/token';
import { tokensWithoutData } from '../selectors/token';
import { CAMPAIGN_EVENTS_FETCHED, CAMPAIGNS_FETCHED } from '../actionTypes';

/**
 * Responsible for fetching information about tokens
 *
 * @param {Object} services
 *
 * @returns {function}
 */
export default ({ dynamicToken }) => ({ dispatch, getState }) => next => async (action) => {
  next(action);

  if (action.type === CAMPAIGN_EVENTS_FETCHED || action.type === CAMPAIGNS_FETCHED) {
    const tokenAddresses = tokensWithoutData(getState());
    if (tokenAddresses.length) {
      try {
        const tokens = await retry(() => dynamicToken.fetchTokenData(tokenAddresses));
        if (tokens.length) {
          dispatch(tokenInfoUpdate(tokens));
        }
      } catch (error) {
        dispatch(tokenInfoUpdateFailed(error));
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/middleware/updateTokenInfo.js